import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import './formato.css';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore, withStore } from 'store';
import { useHistory } from 'react-router-dom';
import { postGuests } from 'services/rsvp/getRSVP';
import styles from './styles.module.scss';

const MyGuestsAdd = ({ typeId }) => {
  const history = useHistory();

  const [nombre, setNombre] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [correo, setCorreo] = useState('');
  const [edad, setEdad] = useState('');
  const [telefono, setTelefono] = useState('');
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [jsonResultado, setJsonResultado] = useState(null);


  // Función para manejar el envío del formulario
  const handleSubmit = (e) => {
    // activa patalla de cargando
    dispatch(showLoader());

    e.preventDefault();

    // Crear el objeto JSON con los datos del formulario
    const nuevoRegistro = {
      typeId,
      nombre,
      apellidos,
      correo,
      edad,
      telefono,
    };

    // Actualizar el estado del resultado JSON
    setJsonResultado(nuevoRegistro);

  };

  useEffect(() => {
    if (jsonResultado !== null) {
      //  alert('JsonResultado ' + JSON.stringify(jsonResultado, null, 2));           // Eliminar 
      // Limpiar los campos del formulario
      setJsonResultado(null);
      setNombre('');
      setApellidos('');
      setCorreo('');
      setEdad('');
      setTelefono('');

      // Enviar el objeto JSON al backend para guardar en la base de datos
      postGuests(typeId, jsonResultado).then((valorDeServicio) => {
        console.log('putGuests ', valorDeServicio);

        // Valida la respuesta del backend
        if(valorDeServicio?.metadata?.http_status === 400){
          alert(valorDeServicio?.data?.message);
          dispatch(hideLoader());
        }else{
          dispatch(hideLoader());
          history.push('/muestra-invitados');
        }
        // desactiva patalla de cargando y redireciona
      });
    }
  }, [jsonResultado]);

  const handleTelefonoChange = (event) => {
    // Expresión regular que permite solo números
    const regex = /^[0-9]+$/;
    const inputValue = event.target.value;

    if (regex.test(inputValue) || inputValue === '') {
      setTelefono(inputValue);
    }
  };


  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="campo">
          <label>Nombre:</label>
          <input
            type="text"
            placeholder="Nombre del invitado"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
            className={`${styles.inputsborder} form-control`}
          />
        </div>
        <div className="campo">
          <label>Apellidos:</label>
          <input
            type="text"
            placeholder="Apellidos del invitado"
            value={apellidos}
            onChange={(e) => setApellidos(e.target.value)}
            required
            className={`${styles.inputsborder} form-control`}
          />
        </div>
        <div className="campo">
          <label>Correo:</label>
          <input
            type="email"
            placeholder="Correo del invitado"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
            className={`${styles.inputsborder} form-control`}
          />
        </div>
        <div className="campo">
          <label>Edad:</label>
          <select
            value={edad}
            onChange={(e) => setEdad(e.target.value)}
            required
            className={`${styles.inputsborder} form-control`}
          >
            <option value="">Edad</option>
            <option value="adulto">Adulto</option>
            <option value="niño">Niños</option>
            <option value="bebe">Bebé</option>
          </select>
        </div>
        <div className="campo">
          <label>Teléfono:</label>
          <input
            type="tel"
            placeholder="Número de teléfono del invitado"
            value={telefono}
            onChange={(e) => handleTelefonoChange(e)}
            required
            className={`${styles.inputsborder} form-control`}
          />
        </div>
        <div className="campo">
          <Button variant="primary" type="submit"> Agregar invitado </Button>
        </div>
        <br />
      </form>
    </div>
  );
};


export default MyGuestsAdd;
